import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.e4_1 = -9223372036854775808n;
        this.f4_1 = 9223372036854775807n;
        this.g4_1 = 8;
        this.h4_1 = 64;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance3skn40jhkoxyn,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
